import { render, staticRenderFns } from "./RecipeInfo.vue?vue&type=template&id=d4a336c4"
import script from "./RecipeInfo.vue?vue&type=script&lang=js"
export * from "./RecipeInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipeInfo.vue?vue&type=style&index=0&id=d4a336c4&prod&lang=scss"
import style1 from "./RecipeInfo.vue?vue&type=style&index=1&id=d4a336c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports